var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.46 15.6424C12.1857 16.4997 10.6513 17 9 17C7.35027 17 5.81717 16.5006 4.54361 15.6448L8.13269 13.5298L8.37885 13.3848V13.0991V11.673C8.552 11.7166 8.729 11.7396 8.90898 11.7396C9.15526 11.7396 9.39595 11.6966 9.62885 11.6165V13.0991V13.3848L9.875 13.5298L13.46 15.6424ZM14.3108 14.9831L10.6288 12.8134V11.016C11.8161 9.97674 12.6264 7.99546 12.6264 6.26136C12.6264 3.77608 10.962 2.73962 8.90898 2.73962C6.85592 2.73962 5.19159 3.77608 5.19159 6.26136C5.19159 8.08635 6.08904 10.1851 7.37885 11.1715V12.8134L3.69229 14.9858C2.04076 13.5203 1 11.3817 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 11.3802 15.9605 13.5176 14.3108 14.9831ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11.6264 6.26136C11.6264 7.30429 11.2698 8.48918 10.6935 9.39624C10.0955 10.3375 9.43061 10.7396 8.90898 10.7396C8.38735 10.7396 7.72246 10.3375 7.12446 9.39624C6.54821 8.48918 6.19159 7.30429 6.19159 6.26136C6.19159 5.25866 6.51651 4.679 6.9267 4.33159C7.36407 3.96115 8.03586 3.73962 8.90898 3.73962C9.7821 3.73962 10.4539 3.96115 10.8913 4.33159C11.3014 4.679 11.6264 5.25866 11.6264 6.26136Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c17bd8e4419625b32ae131eb20889cac.svg";
export { ForwardRef as ReactComponent };